import {Injectable} from '@angular/core';
import {BaseRequestOptions, Http, Response, URLSearchParams} from '@angular/http';
import {Observable} from 'rxjs/Rx';
import {CONSTANTS} from '../../cadens.constants';

import {Cursus} from './cursus.model';
import {DateUtils} from 'ng-jhipster';

@Injectable()
export class CursusService {

    private resourceUrl = 'api/cursuses';
    private resourceMaxNiveauUrl = 'api/maxniveaucursuses';

    constructor(private http: Http, private dateUtils: DateUtils) { }

    create(cursus: Cursus): Observable<Cursus> {
        let copy: Cursus = Object.assign({}, cursus);
        copy.dateCreation = new Date();
        copy.dateModification = new Date();
        copy.dateDebut = CursusService.convertDate(copy.dateDebut);
        copy.dateFin = CursusService.convertDate(copy.dateFin);
        copy.dateObtentionDiplome = CursusService.convertDate(copy.dateObtentionDiplome);
        return this.http.post(this.resourceUrl, copy).map((res: Response) => {
            return res.json();
        });
    }

    update(cursus: Cursus[]): Observable<Cursus[]> {
        let copy: Cursus[] = [];
        cursus.forEach(c => {
            let cursusCopy: Cursus = {...c};
            // this.convertDates(cursusCopy) ;
            // if (cursusCopy.dateDebut != null && cursusCopy.dateFin != null && cursusCopy.interruption != null) {
                if (!cursusCopy.dateCreation) {
                    cursusCopy.dateCreation = new Date();
                }
                cursusCopy.dateModification = new Date();
                cursusCopy.dateDebut = CursusService.convertDate(c.dateDebut);
                cursusCopy.dateFin = CursusService.convertDate(c.dateFin);
                cursusCopy.dateObtentionDiplome = CursusService.convertDate(c.dateObtentionDiplome);
                copy.push(cursusCopy);
            // }
        });
        if (copy.length > 0) {
            return this.http.put(this.resourceUrl, copy).map((res: any) => this.convertCursusResponse(res));
        }
        return Observable.of([]);
    }

    find(id: number): Observable<Cursus> {
        return this.http.get(`${this.resourceUrl}/${id}`).map((res: Response) => {
            let jsonResponse = res.json();
            this.convertDates(jsonResponse);
            return jsonResponse;
        });
    }


    query(req?: any): Observable<Cursus> {
        let params = new URLSearchParams();
        if (req.candidatureId) {
            params.set('candidatureId', req.candidatureId);
        }
        return this.http.get(this.resourceUrl, { search: params })
            .map((res: any) => this.convertCursusResponse(res))
            ;
    }

    findMaxNiveau(): Observable<Cursus> {
        return this.http.get(this.resourceMaxNiveauUrl)
            .map((res: any) => this.convertCursusResponse(res))
            ;
    }

    delete(id: number): Observable<Response> {
        return this.http.delete(`${this.resourceUrl}/${id}`);
    }

    static areCursusesValid(cursus: Cursus[], reinscription?: boolean): any {
        for (let i = 0; cursus.length > i; i++) {
            if (cursus[i].dateDebut == null) {
                return 'dateDebut';
            }
            if (cursus[i].dateFin == null) {
                return 'dateFin';
            }
            if (cursus[i].interruption == null) {
                return 'interruption';
            }
            if (cursus[i].interruption === false && cursus[i].pays === '100' && cursus[i].etablissement == null) {
                return 'etablissement';
            }
            if (!reinscription && cursus[i].interruption === false && cursus[i].anneeSanctionnee == null) {
                return 'anneeSanctionnee';
            }

            // mise date obtention diplome à null si en attente résultat diplome
            if (cursus[i].mention == CONSTANTS.MENTION_ATTENTE_RESULTAT_CODE.toString()) {
                cursus[i].dateObtentionDiplome = null ;
            }

            if (!reinscription && cursus[i].anneeSanctionnee === true
                && (cursus[i].dateObtentionDiplome == null && cursus[i].mention != CONSTANTS.MENTION_ATTENTE_RESULTAT_CODE.toString())) {
                return 'dateObtentionDiplome';
            }
            let d = new Date();
            if (reinscription && cursus[i].dateDebut.getFullYear() < d.getFullYear() - 2) {
                return 'dateDebutReinscription';
            }
        }
        return null;
    }

    private convertCursusResponse(res: any): any {
        if (res.json != null && typeof res.json != "undefined") {
            let jsonResponse = res.json();
            for (let i = 0; i < jsonResponse.length; i++) {
                this.convertDates(jsonResponse[i]);
            }
            res._body = jsonResponse;
        }
        return res;
    }

    private convertDates(jsonCursus: Cursus) {
        jsonCursus.dateDebut = this.dateUtils
            .convertLocalDateFromServer(jsonCursus.dateDebut);
        jsonCursus.dateFin = this.dateUtils
            .convertLocalDateFromServer(jsonCursus.dateFin);
        jsonCursus.dateObtentionDiplome = this.dateUtils
            .convertLocalDateFromServer(jsonCursus.dateObtentionDiplome);
        jsonCursus.dateCreation = this.dateUtils
            .convertDateTimeFromServer(jsonCursus.dateCreation);
        jsonCursus.dateModification = this.dateUtils
            .convertDateTimeFromServer(jsonCursus.dateModification);
    }

    private static createRequestOption(req?: any): BaseRequestOptions {
        let options: BaseRequestOptions = new BaseRequestOptions();
        if (req) {
            let params: URLSearchParams = new URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.candidatureId) {
                params.set('candidatureId', req.candidatureId);
            }
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            params.set('query', req.query);

            options.search = params;
        }
        return options;
    }

    private static convertDate(date) {
        if (date == null) {
            return null;
        }
        return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/candidature/cursus.service.ts